export default __webpack_public_path__ + "static/media/equalizer.8df20af5.png";